define([
    './eTracker',
    './eTrackerAdapterProvider',
], (
    eTracker,
    eTrackerAdapterProvider
) => {
    angular.module('customer.edge.platform.tracking.adapters', [])
        .factory('eTracker', eTracker)
        .provider('adapters.eTracker', eTrackerAdapterProvider);
});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/tracking/adapters/module.js